export default "__VITE_ASSET__Ci6MgQoH__"